import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5e93de8c")

_pushScopeId("data-v-5e93de8c")
const _hoisted_1 = { class: "home" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache) {
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_Content = _resolveComponent("Content")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Sidebar),
    _createVNode(_component_Content)
  ]))
})